import { useEffect, useRef, useState } from "react";

export const useInViewport = <TElement extends Element>({
  rootMargin = "0px",
  once = true,
}: {
  rootMargin?: string;
  once?: boolean;
} = {}) => {
  const ref = useRef<TElement | null>(null);
  const [isInViewport, setIsInViewport] = useState(false);

  useEffect(() => {
    const element = ref.current;
    if (!element) return;

    if (typeof IntersectionObserver === "undefined") {
      setIsInViewport(true);
      return;
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        const nextIsInViewport = entry.isIntersecting;
        setIsInViewport(nextIsInViewport);

        if (nextIsInViewport && once) {
          observer.disconnect();
        }
      },
      { rootMargin },
    );

    observer.observe(element);

    return () => observer.disconnect();
  }, [once, rootMargin]);

  return { ref, isInViewport };
};
